import { render, staticRenderFns } from "./spotManage.vue?vue&type=template&id=38805336&scoped=true&"
import script from "./spotManage.vue?vue&type=script&lang=js&"
export * from "./spotManage.vue?vue&type=script&lang=js&"
import style0 from "./spotManage.vue?vue&type=style&index=0&id=38805336&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38805336",
  null
  
)

export default component.exports